import type { ReactElement } from "react";

import { translate } from "app/filters/i18nFilter";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { FilterResultContainer } from "app/pages/sales-intelligence/common-components/filters-panel/components/styles";
import CrmFilterChipsItems from "app/pages/sales-intelligence/modules/leads-search-filters/components/CrmFilterChipsItems/CrmFilterChipsItems";
import { useCrmFilterResultLogic } from "app/pages/sales-intelligence/modules/leads-search-filters/hooks/useCrmFilterResultLogic";
import type ExcludeByCrmFilter from "app/pages/sales-intelligence/modules/leads-search-filters/models/ExcludeByCrmFilter/ExcludeByCrmFilter";
import { inclusionOptionMap } from "app/pages/sales-intelligence/types/commonMaps";

import { OWNER_NAMES, OWNER_CHIP } from "./const";

const ExcludeByCrmFilterResultContainer = ({
    filter: {
        options: { integrationName, fields },
    },
    value,
    isExpanded,
    isActionEnabled = true,
    onFilterUpdate,
    onFilterValueRemove,
}: IFilterViewBaseProps<ExcludeByCrmFilter>): ReactElement | null => {
    const fieldLabelsOverride = {
        [OWNER_NAMES]: translate(OWNER_CHIP),
    };
    const { fieldLabels, onDelete } = useCrmFilterResultLogic({
        integrationName,
        fields,
        value,
        onFilterUpdate,
        fieldLabelsOverride,
        inclusion: inclusionOptionMap.excludeOnly,
        onFilterValueRemove,
    });

    if (!value) {
        return null;
    }

    return (
        <FilterResultContainer>
            <CrmFilterChipsItems
                values={value?.listFieldsFilters}
                fields={fields}
                fieldLabels={fieldLabels}
                isExpanded={isExpanded}
                hideActionButton={!isActionEnabled}
                onDelete={onDelete}
            />
        </FilterResultContainer>
    );
};

export default ExcludeByCrmFilterResultContainer;
